export const routes = (parentName) => {
  return [
    {
      path: "deposit",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Deposit`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "",
          name: `${parentName}-Deposit-List`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-special",
          name: `${parentName}-Deposit-List-Special`,
          component: () => import("./ListSpecial.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "list-deposit",
          name: `${parentName}-Deposit-List-Deposit`,
          component: () => import("./ListDeposit.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "new",
          name: `${parentName}-Deposit-New`,
          component: () => import("./Upsert.vue"),
        },
        {
          path: ":id",
          name: parentName + "-" + "Deposit-View",
          component: () => import("./View.vue"),
        },
        {
          path: ":id/edit",
          name: parentName + "-" + "Deposit-Edit",
          component: () => import("./Upsert.vue"),
        },
      ],
    },
  ];
};
